import {
  ACCOUNT_LINK_TYPE,
  CommentaryEntityContext,
  commentaryCountKey,
} from '@helios/common-api'

export interface CommentaryAccountCounts {
  readonly accountId: string
  readonly byLinkKey: Record<string, number>
  readonly total: number
}

export interface CommentaryCountDimension {
  countIn(
    counts: CommentaryAccountCounts,
    context: CommentaryEntityContext,
  ): number
}

function countOfLink(
  counts: CommentaryAccountCounts,
  linkType: string,
  id: string | undefined,
): number | undefined {
  return counts.byLinkKey[commentaryCountKey(linkType, id)]
}

export function linkCounts(
  linkType: string,
  idOf: (context: CommentaryEntityContext) => string | undefined,
): CommentaryCountDimension {
  return {
    countIn: (counts, context) =>
      countOfLink(counts, linkType, idOf(context)) ?? 0,
  }
}

export const transactionCounts = linkCounts(
  'tran',
  context => context.transactionId,
)

export const externalTransactionCounts = linkCounts(
  'exttran',
  context => context.extTranId,
)

export const breakCounts = linkCounts('break', context => context.breakId)

export const assetCounts = linkCounts('asset', context => context.assetId)

export const suspenseCounts = linkCounts(
  'suspense',
  context => context.suspenseId,
)

export const accountCounts: CommentaryCountDimension = {
  countIn: counts =>
    countOfLink(counts, ACCOUNT_LINK_TYPE, counts.accountId) ?? counts.total,
}
